module.exports = (__webpack_require__(7))(154);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/rxjs/observable/fromPromise.js from dll-reference vendor
// module id = 1223
// module chunks = 0